module.exports = "query AllianceCustomersPrologueIdsQuery{allianceCustomersPrologueIds}"